export default "__VITE_ASSET__4c474c7a__"